import React, { useEffect, useState } from 'react';
import './Home.css';
// Footer component
import Footer from './Footer';

// --- DATA ARRAYS ---
const heroImages = [
  '/physio1.png',
  '/physio2.png',
  '/physio3.png',
  '/physio4.png',
  '/physio5.png',
];

const techImages = [
  '/tech1.jpg',
  '/tech2.jpg',
  '/tech3.png',
  '/tech4.jpg',
  '/tech5.jpg',
  '/tech6.jpg',
  '/tech7.jpg',
  '/tech8.jpg',
  '/tech9.jpg',
];

const whyUsPoints = [
  {
    title: "Expertise Across Specializations",
    text: "Our team comprises skilled physiotherapists with expertise in Musculoskeletal, Neurological, Geriatric, and Women's health. Whatever your concerns, we have the specialized knowledge to address them."
  },
  {
    title: "State-of-the-Art Modalities",
    text: "Embracing innovation, we utilize the latest physiotherapy modalities, ensuring you receive cutting-edge treatments that optimize your healing journey."
  },
  {
    title: "Patient-Centric Approach",
    text: "Your health is our priority. We take the time to understand your individual needs, crafting personalized treatment plans that align with your goals for recovery and overall well-being."
  },
  {
    title: "Comprehensive Care Settings",
    text: "Whether you prefer the convenience of clinic visits or the comfort of home-based therapy, we offer versatile care settings to accommodate your preferences."
  }
];

const Home = ({ onNavigate }) => {
  // State for Hero Slider
  const [activeSlide, setActiveSlide] = useState(0);
  // State for Modalities/Tech Slider
  const [activeTechSlide, setActiveTechSlide] = useState(0);

  // Hero Slider Logic
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((current) =>
        current === heroImages.length - 1 ? 0 : current + 1
      );
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  // Modalities Carousel Logic
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTechSlide((current) =>
        current === techImages.length - 1 ? 0 : current + 1
      );
    }, 4000); // Slightly slower interval for tech slides
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">
      <div className="main-content">

        {/* --- 1. HERO SECTION (UNCHANGED) --- */}
        <section className="hero-section home-layer active">
          <div className="hero-text">
            <h1>Rebuilding Movement.<br />Restoring Life.</h1>
            <p>A new standard of physiotherapy combining human care with medical technology.</p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={() => document.getElementById('mission-section').scrollIntoView({ behavior: 'smooth' })}>Get Started</button>
              <button className="btn-secondary" onClick={() => onNavigate('about')}>Learn More</button>
            </div>
          </div>
          <div className="hero-visual">
            <div className="slider-container">
              {heroImages.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`Physiotherapy ${idx + 1}`}
                  className={`hero-image-slide ${activeSlide === idx ? 'active' : ''}`}
                />
              ))}
            </div>
            <div className="slider-progress-container">
              <div className="slider-progress-bar" style={{ width: `${((activeSlide + 1) / heroImages.length) * 100}%` }}></div>
            </div>
          </div>
        </section>

        {/* --- 2. MISSION SECTION (UNCHANGED) --- */}
        <section id="mission-section" className="section-mission">
          <div className="mission-layout">
            <div className="mission-visual-col">
              <div className="mission-collage">
                <img src="/Mission.png" alt="Mission" className="mission-img-main" />
                <div className="mission-backdrop-box"></div>
              </div>
            </div>
            <div className="mission-text-col">
              <h2 className="section-title">Mission & <span className="highlight-text">Vision</span></h2>
              <div className="mission-block">
                <h3>A Vision for the Future</h3>
                <p>We envision a world where <span className="highlight-text">personalized and innovative physiotherapy</span> transforms lives.</p>
              </div>
              <div className="mission-block">
                <h3>Beacon of Excellence</h3>
                <p>We strive to be a beacon of excellence by offering specialized services backed by the <span className="highlight-text">latest advancements</span>.</p>
              </div>
              <div className="mission-block">
                <h3>Dedicated Professionals</h3>
                <p>Our team is committed to fostering your health and well-being through a <span className="highlight-text">holistic approach</span>.</p>
              </div>
            </div>
          </div>
        </section>

        {/* --- 3. WHY CHOOSE US (NUMBERS REMOVED AS REQUESTED) --- */}
        <section className="section-why-us">
          <div className="orb orb-why-us"></div>
          <div className="section-header-center">
            <h2 className="section-title centered">Why Choose <span className="highlight-text">US</span>?</h2>
            <p className="section-sub">Dedicated to providing top-tier physiotherapy services using modern technology.</p>
          </div>
          <div className="why-us-grid">
            {whyUsPoints.map((point, idx) => (
              <div className="glass-feature-card" key={idx}>
                {/* Number removed from here */}
                <h3 className="feature-title">{point.title}</h3>
                <p className="feature-desc">{point.text}</p>
                <div className="feature-shine"></div>
              </div>
            ))}
          </div>
        </section>

        {/* --- 4. NEW SECTION: OUR MODALITIES --- */}
        <section className="section-modalities">
          {/* Background decorative orb */}
          <div className="orb orb-modalities"></div>

          <div className="modalities-layout">
            {/* Text Column */}
            <div className="modalities-text-col">
              <h2 className="section-title">Our <span className="highlight-text">Modalities</span></h2>
              <div className="modalities-description">
                <p className="desc-intro">We take pride in offering a spectrum of specialized physiotherapy services supported by <b>state-of-the-art modalities</b>.</p>
                <p>Our commitment is to provide you with the most advanced and effective treatments for your unique needs. Discover the synergy of specialized services and our cutting-edge modalities, where we strive to elevate the standard of physiotherapy care, ensuring your journey to wellness is transformative and empowering.</p>
              </div>
              {/* Button to Technology page */}
              <button className="btn-primary btn-tech-cta" onClick={() => onNavigate('technology')}>
                Explore Our Technology
              </button>
            </div>

            {/* Carousel Column */}
            <div className="modalities-visual-col">
              <div className="tech-carousel-wrapper">
                <div className="tech-carousel-frame">
                  {techImages.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt={`Physiotherapy Technology ${idx + 1}`}
                      className={`tech-image-slide ${activeTechSlide === idx ? 'active' : ''}`}
                    />
                  ))}
                </div>
                {/* Carousel Indicators/Dots */}
                <div className="tech-carousel-indicators">
                  {techImages.map((_, idx) => (
                    <span
                      key={idx}
                      className={`indicator-dot ${activeTechSlide === idx ? 'active' : ''}`}
                      onClick={() => setActiveTechSlide(idx)} // Allow manual clicking
                    ></span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* =========================================
            5. COMPACT FOOTER
           ========================================= */}
        <Footer />

      </div>
    </div>
  );
};

export default Home;